import Swiper from 'swiper';
import { Metrika } from '../components/metrika';

export function stepsSlider() {
    const metrika = new Metrika;

    let sliderSteps = new Swiper('.steps-slider', {
        containerModifierClass: 'steps-slider',
        wrapperClass: 'steps-slider__wrapper',
        slideClass: 'steps-slide',
        slideActiveClass: 'is-active',
        width: 290,
        allowTouchMove: false,
        breakpoints: {
            767: {
                width: 560,
            },
            320: {
                width: 272,
            },
        }
    });

    let bullets = document.querySelectorAll('[am-item="steps"]'),
        btn = document.querySelector('[am-btn="steps"]'),
        prev = document.querySelector('[am-prev="steps"]'),
        next = document.querySelector('[am-next="steps"]');

    function pagination(index) {
        bullets.forEach( function(item) {
            item.classList.remove('is-active');
            item.classList.remove('is-prev');
        });

        for (let i = 0; i <= index; i++) {
            bullets[i].classList.add('is-active');

            if ( i > 0 ) {
                bullets[i-1].classList.add('is-prev');
            }

            if (i == 6) {
                btn.classList.add('is-active');
                next.classList.add('is-hidden');
            } else {
                btn.classList.remove('is-active');
                next.classList.remove('is-hidden');
            }
        }
    };

    sliderSteps.on('slideChange', function() {
        let index = this.realIndex,
            slider = document.querySelector('.steps-slider');

        pagination(index);

        // Яндекс метрика
        if (index == 1) {
            metrika.reachGoal('go_2_stage_form', slider);
        } else if (index == 6) {
            metrika.reachGoal('go_last_stage_form', slider);
        }
    });

    bullets.forEach( function(item) {
        item.addEventListener('click', function() {
            let index = item.textContent - 1;
            sliderSteps.slideTo(index);
            pagination(index);
        });
    });

    if (prev) {

        prev.addEventListener('click', function() {
            sliderSteps.slidePrev()
        });

        next.addEventListener('click', function() {
            sliderSteps.slideNext()
        });

    }

    if (window.innerWidth > 501 || !prev) {
        return false;
    }

    let sliderStepsThumbs = new Swiper('.steps-thumbs-slider', {
        containerModifierClass: 'steps-thumbs-slider',
        wrapperClass: 'steps-thumbs-slider__wrapper',
        slideClass: 'steps-thumbs-slide',
        width: 36,
        spaceBetween: 35,
    })

    let visibleBulets = Math.floor(window.innerWidth / 71),
        maxTranslater = (visibleBulets - 1) * 71 - 460;

    sliderStepsThumbs.on('slideChange', () => {
        if (sliderStepsThumbs.translate < maxTranslater) {
            sliderStepsThumbs.setTranslate(maxTranslater)
        }
    });

    prev.addEventListener('click', function() {
        if (visibleBulets == sliderSteps.activeIndex + 1) {
            sliderStepsThumbs.translateTo(0, 400)
        }
    });

    next.addEventListener('click', function() {
        if (visibleBulets < sliderSteps.activeIndex + 1) {
            sliderStepsThumbs.translateTo(maxTranslater, 400)
        }

    });
}